// Styles
import '../sass/main.scss';
import './checkout.js';
import './pre-order.js';
import './single';
import './cart';
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/modal";
import './register.js';

jQuery(function($){
    // $(".single-product .entry-title").addClass(["offset-md-6", "ps-md-4"]);
    jQuery('.actions').find('button').removeAttr('aria-disabled').prop('disabled', false);
});

jQuery('#login-register a').on('click', function (e) {
  e.preventDefault()
  jQuery(this).tab('show')
})

jQuery('<div class="product-breadcrumb pb-4 pb-md-0 mb-5">TERMÉKEK</div>').insertBefore('.single-product .page-header');

jQuery('.single-product .single-product-main-image').removeClass('woocommerce-product-gallery__image');

jQuery('#birthdate').attr('max', '9999-12-31');

